// 7.2.8 IsRegExp(argument)
var isObject = require('./_is-object');
var cof = require('./_cof');
var MATCH = require('./_wks')('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/_is-regexp.js
 ** module id = 196
 ** module chunks = 0
 **/